import { Ionicons } from "@expo/vector-icons";
import { observer } from "mobx-react";
import React, { useState } from "react";
import { Dimensions, StyleSheet, Text, TouchableOpacity, View } from "react-native";
import { Button, Input } from "react-native-elements";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import { RFValue } from "react-native-responsive-fontsize";
import CustomHeader from "../../components/CustomHeader";
import MenuIcon from "../../components/icons/MenuIcon";
import isValidEmail from "../../functions/isValidEmail";
import invite from "../../networking/api/user/invite";
import state from "../../store/Store";

const { height, width } = Dimensions.get("window");
const init = { email: "", name: "", phone: "" };

const AddModerators = observer(({ navigation }) => {
  const [data, setData] = useState([init]);
  const onChange = (i, attr, value) => setData(data.map((k, m) => (m === i ? { ...k, [attr]: value } : k)));

  const disabled = data.some((o) => !isValidEmail(o.email) || !o.name || !o.phone);
  return (
    <View style={styles.container}>
      <CustomHeader title="Add Moderators" leftIcon={<MenuIcon navigation={navigation} />} />
      <KeyboardAwareScrollView contentContainerStyle={styles.contentContainerStyle} extraScrollHeight={height * 0.05}>
        {data?.map((o, i) => {
          return (
            <View style={styles.rowView} key={o + i.toString()}>
              <Input
                value={o.email}
                inputStyle={styles.inputStyle}
                autoCapitalize="none"
                keyboardType="email-address"
                containerStyle={styles.containerStyle}
                inputContainerStyle={styles.inputContainerStyle}
                placeholder="Email Address"
                onChangeText={(e) => onChange(i, "email", e)}
              />
              <Input
                value={o.name}
                inputStyle={styles.inputStyle}
                autoCapitalize="words"
                containerStyle={styles.containerStyle}
                inputContainerStyle={styles.inputContainerStyle}
                placeholder="Full Name"
                onChangeText={(e) => onChange(i, "name", e)}
              />
              <Input
                value={o.phone}
                inputStyle={styles.inputStyle}
                keyboardType="phone-pad"
                containerStyle={styles.containerStyle}
                inputContainerStyle={styles.inputContainerStyle}
                placeholder="Phone Number"
                onChangeText={(e) => onChange(i, "phone", e)}
              />
              {data.length === 1 ? null : (
                <Ionicons
                  name="ios-remove-circle"
                  size={35}
                  color="red"
                  style={styles.iconContainer}
                  onPress={() => setData(data.filter((u, p) => p !== i))}
                />
              )}
            </View>
          );
        })}

        {data.length === 10 ? null : (
          <TouchableOpacity
            activeOpacity={1}
            style={[styles.rowView, { marginHorizontal: 5 }]}
            onPress={() => setData([...data, init])}>
            <Ionicons name="add-circle" size={28} color="green" />
            <Text style={styles.inputStyle}>Add More</Text>
          </TouchableOpacity>
        )}
      </KeyboardAwareScrollView>
      <Button
        title="Send Invite"
        disabled={disabled}
        containerStyle={styles.buttonContainer}
        buttonStyle={styles.buttonStyle}
        titleStyle={styles.titleStyle}
        onPress={async () => {
          let res = await invite(state.accessToken, data);
          if (res) setData([init]);
        }}
      />
    </View>
  );
});

export default AddModerators;

const styles = StyleSheet.create({
  buttonContainer: { alignSelf: "center" },
  titleStyle: { fontFamily: "avenir" },
  buttonStyle: {
    backgroundColor: "#181d21",
    paddingHorizontal: width * 0.05,
    marginBottom: 5,
  },
  contentContainerStyle: { flexGrow: 0, paddingVertical: height * 0.05 },
  rowView: {
    flexDirection: "row",
    alignItems: "center",
    marginVertical: 5,
  },
  inputStyle: { fontFamily: "avenir", fontSize: RFValue(11), outlineWidth: 0 },
  containerStyle: { flex: 1 },
  iconContainer: { flex: 0.25, marginBottom: height * 0.025 },
  inputContainerStyle: {
    borderWidth: 1,
    borderRadius: 5,
    paddingHorizontal: 5,
  },
  container: { flex: 1 },
  textStyle: { fontFamily: "avenir", fontSize: RFValue(10) },
});
